import { phoneModel } from '@/utils/userAgent';
import { iBoxBridge, IBOX_BROWSER_ACTION_ENUM } from 'izen-common-utils';
import { Dispatch } from 'react';
export function isApp() {
  return (
    !!~navigator.userAgent.toLowerCase().indexOf('ibox_app') ||
    !!~navigator.userAgent.toLowerCase().indexOf('ibox_app｜ibox_app_lite')
  );
}

// 20000007 类型
export enum refreshType {
  myNativePage = 1, //我的持仓
}

export const AppUtil = {
  async initAppInfo() {
    if (!isApp()) return;
    if (!window.localStorage.getItem('header_safe_distance')) {
      const top = await AppUtil.getHeaderBarHeight();
      window.localStorage.setItem('header_safe_distance', top + '');
    }
    if (isApp()) {
      const res: any = await AppUtil.GetUserInfo();
      if (res?.userInfo) window.localStorage.setItem('userInfo', res.userInfo);
    }
  },
  async getUserInfoData() {
    if (isApp()) {
      const res: any = await AppUtil.GetUserInfo();
      window.localStorage.setItem('userInfo', res.userInfo);
      return JSON.parse(res.userInfo);
    }
    return JSON.parse(window.localStorage.getItem('userInfo') || '{}');
  },
  callShare(data: {
    type: number; //0、1、2、 (0，微信、1 朋友圈、2 保存图片),
    title?: string;
    content?: string;
    url?: string;
    base64Img?: string;
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.ShareChannel,
        data,
      });
      resolve();
    });
  },
  goAddress() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoAddress,
      });
      resolve();
    });
  },
  goCreator(uid: number) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.HIBActionOpenCreator,
        data: { uid },
      });
      resolve();
    });
  },
  goBrand(brandId: number) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.HIBActionOpenBrandPage,
        data: { brandId },
      });
      resolve();
    });
  },
  doSDKAuthentication(data?: { certifyId?: string; bizType?: string }) {
    return new Promise<any>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.DoAuthentication,
        data,
        callback: (response) => {
          resolve(response);
        },
      });
    });
  },
  goIdentity() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoIdentity,
      });
      resolve();
    });
  },
  login(data?: { phone?: string | number }) {
    return new Promise(() => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.Login,
        data,
        callback: () => {
          location.reload();
        },
      });
    });
  },
  checkToken(data?: {
    isOpenLogin?: boolean; // 控制是否自动跳转登录
  }) {
    return new Promise((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.CheckToken,
        data,
        callback: (response) => {
          resolve(response || {});
        },
      });
    });
  },
  goodsResell(data: any) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoodsResellSuccess,
        data,
      });
      resolve();
    });
  },
  mboxResell(data: any) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.MboxResellSuccess,
        data,
      });
      resolve();
    });
  },
  goAccount() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.BackPersonCenter,
      });
      resolve();
    });
  },
  goAlbumDetail(data: {
    aid: number; // 专辑id
    gid?: number; // 商品id
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GoodsDetail,
        data,
      });
      resolve();
    });
  },
  closePage() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        data: { tiem: new Date().getTime() },
        action: IBOX_BROWSER_ACTION_ENUM.ClosePage,
      });
      resolve();
    });
  },
  getHeaderBarHeight() {
    return new Promise((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.GetHeaderBarHeight,
        callback: (data) => {
          resolve(data?.statusBarHeight || 0);
        },
      });
    });
  },
  setHeaderBar(data: {
    statusBarStyle: number; // (0 默认黑色、1 白色)
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.SetHeaderBar,
        data,
      });
      resolve();
    });
  },
  logoff() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 注销账户
        action: IBOX_BROWSER_ACTION_ENUM.Logoff,
      });
      resolve();
    });
  },
  linkOutApp(data: {
    type: number;
    appSchemeUrl: string;
    appDownloadUrl: string;
  }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 跳转外部app
        action: IBOX_BROWSER_ACTION_ENUM.LinkOutApp,
        data,
      });
      resolve();
    });
  },
  linkWxProgram(data: { wxProgramId: string; path?: string }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 跳转微信小程序
        action: IBOX_BROWSER_ACTION_ENUM.LinkWxProgram,
        data,
      });
      resolve();
    });
  },
  openView(data: { url: string }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 跳转webview或者app页面
        action: IBOX_BROWSER_ACTION_ENUM.OpenView,
        data,
      });
      resolve();
    });
  },
  getAppInfo() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 获取app信息
        action: IBOX_BROWSER_ACTION_ENUM.GetAppInfo,
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  // 刷新上个Native页面的接口
  refresPreNativePage(type: number) {
    return new Promise<void>(() => {
      iBoxBridge.jsCallNative({
        //@ts-ignore 获取app信息
        action: IBOX_BROWSER_ACTION_ENUM.refresPreNativePage,
        data: {
          type,
        },
      });
    });
  },
  // 跳转新页面 & 关闭当前webview
  OpenViewAndClosePrevPage(data: { url: string }) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        action: IBOX_BROWSER_ACTION_ENUM.OpenViewAndClosePrevPage,
        data,
      });
      resolve();
    });
  },
  // 获取用户信息
  GetUserInfo() {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '10000018',
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  // 加密json
  EncryptedJsonData(data: any) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000014',
        data: { decryptData: data },
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  // 解密json
  DecodeJsonData(data: any) {
    return new Promise<void>((resolve) => {
      iBoxBridge.jsCallNative({
        //@ts-ignore
        action: '20000009',
        data: { encryptData: data },
        callback: (data) => {
          resolve(data);
        },
      });
    });
  },
  // 仅iOS）获取iOS是否正在审核中
  iOSAuditState() {
    if (phoneModel().isiOS) {
      return new Promise<void>((resolve) => {
        iBoxBridge.jsCallNative({
          //@ts-ignore
          action: '20000016',
          callback: (data) => {
            resolve(data);
          },
        });
      });
    } else {
      return false;
    }
  },
};

export function currentSystem() {
  //@ts-ignore
  if (process.server) return '';
  const u = navigator.userAgent;
  const ua = u.toLowerCase();
  let type = '';
  if (/iphone|ipad|ipod/.test(ua)) {
    // iOS 系统 ->  跳AppStore下载地址
    type = 'iOS';
  } else if (/android/.test(ua)) {
    // 安卓系统 -> 跳安卓端下载地址
    type = 'android';
  } else {
    type = 'pc';
  }
  return type;
}

export const getAppInit = async (setTop: Dispatch<number>) => {
  if (isApp()) {
    if (!window.localStorage.getItem('header_safe_distance')) {
      const top = await AppUtil.getHeaderBarHeight();
      setTop(
        Number(top || window.localStorage.getItem('header_safe_distance')),
      );
      window.localStorage.setItem('header_safe_distance', top + '');
    } else {
      setTop(Number(window.localStorage.getItem('header_safe_distance')));
    }
  }
};
